/**
 * D453: the themes open for new worlds. Kept apart from the theme files so a theme can be
 * closed or reopened by one line. A world already made in a theme not on the list keeps
 * working; only making a new one is refused.
 */
import { z } from 'zod';
import openThemesFile from '../content/open_themes.json' with { type: 'json' };
import { DEFAULT_IDLE_THEME, isIdleTheme } from './idle.ts';

export const OpenThemesSchema = z.object({
  openThemes: z
    .array(z.string())
    .min(1)
    .refine((l) => new Set(l).size === l.length, 'a theme is listed twice')
    .refine((l) => l.every(isIdleTheme), 'every open theme must be a known theme')
    .refine((l) => l.includes(DEFAULT_IDLE_THEME), 'the default theme must stay open'),
});

const OPEN_THEMES: readonly string[] = OpenThemesSchema.parse(openThemesFile).openThemes;

/** D453: the ids of the themes a new world may take, in order. */
export function openThemeIds(): string[] {
  return [...OPEN_THEMES];
}

/** D453: whether a new world may be made in `id`. */
export function isThemeOpen(id: unknown): id is string {
  return typeof id === 'string' && OPEN_THEMES.includes(id);
}
